import { Image, Input, Table, TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import AddIcon from "components/Icons/AddIcon";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon, statusBadge } from "components/Table";
import Action from "./components/Action";
import { RouteName } from "constants/route";
import useFleetModel from "hooks/fleetModels/useFleetModel";
import { IFleetModel } from "models/fleetModel";
import { FleetModelAlertContextProvider } from "./components/FleetModelAlertContext";

export default function FleetModel() {
  const {
    data: { data, loading, page, per_page, search, total },
    handleSearch,
    handlePageChange,
  } = useFleetModel();

  return (
    <FleetModelAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <Link
              to={RouteName.CREATE_FLEET_MODEL}
              className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
            >
              <AddIcon />
              <span className="text-black text-sm font-medium">
                Add Fleet Model
              </span>
            </Link>
          </div>
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </FleetModelAlertContextProvider>
  );
}

const columns: TableColumnsType<IFleetModel> = [
  {
    title: "Fleet Photo",
    dataIndex: "image",
    render: (image: string) => (
      <Image
        height={50}
        width={60}
        className="rounded object-cover"
        src={image}
        preview={true}
      />
    ),
  },
  {
    title: "Model Name",
    dataIndex: "name",
    sortIcon,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Seat Number",
    dataIndex: "seat_number",
    sortIcon,
    sorter: (a, b) => a.seat_number - b.seat_number,
  },
  {
    title: "Base Fare",
    dataIndex: "base_fare",
    sortIcon,
    sorter: (a, b) => a.base_fare - b.base_fare,
  },
  {
    title: "Price Per Kilo Meter",
    dataIndex: "price_per_kilo_meter",
    sortIcon,

    sorter: (a, b) => a.price_per_kilo_meter - b.price_per_kilo_meter,
  },
  {
    title: "Is Shared",
    dataIndex: "is_shared",
    render: (value: boolean) => <p>{value ? "Yes" : "No"}</p>,
  },
  {
    title: "Status",
    dataIndex: "is_active",
    sortIcon,
    sorter: (a, b) => Number(a.is_active) - Number(b.is_active),
    render: statusBadge,
  },
  {
    title: "Action",
    render: (value: IFleetModel) => <Action fleetModel={value} />,
  },
];
